import { render } from "./GameManagement.vue?vue&type=template&id=69d85e2b&scoped=true"
import script from "./GameManagement.vue?vue&type=script&lang=js"
export * from "./GameManagement.vue?vue&type=script&lang=js"

import "./GameManagement.vue?vue&type=style&index=0&id=69d85e2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d85e2b"]])

export default __exports__